import React, { useMemo } from "react";
import styles from "./style.module.scss";
import { useSelector } from "react-redux";
import { RootState } from "../../../state";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  LineElement,
  PointElement,
} from "chart.js";
import { Line } from "react-chartjs-2";
import { isEqual } from "lodash";
import { StrategyImport } from "../../../types/imports";

ChartJS.register(CategoryScale, LinearScale, LineElement, PointElement);

function RacingLineGraph() {
  const strategyImport: StrategyImport | null = useSelector(
    (state: RootState) => state.imports?.importPreviews?.strategy,
    isEqual,
  );

  const chartData = useMemo(() => {
    if (
      !strategyImport ||
      !strategyImport.data ||
      !strategyImport.data.refLapData
    ) {
      return {
        labels: [],
        datasets: [],
      };
    }

    const refLapLat = strategyImport.data.refLapData[0];
    const refLapLon = strategyImport.data.refLapData[1];

    console.log("Race Line Coords Lat:", refLapLat);
    console.log("Race Line Coords Lon:", refLapLon);

    const coordinateData = refLapLat.map((lat: number, index: number) => ({
      x: refLapLon[index],
      y: lat,
    }));

    return {
      labels: [],
      datasets: [
        {
          label: "Racing Line",
          data: coordinateData,
          pointRadius: 0,
          borderColor: "#A18B6B",
          borderWidth: 2,
          showLine: true,
        },
      ],
    };
  }, [strategyImport]);

  const chartOptions = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      datalabels: {
        display: false,
      },
      legend: {
        display: false,
      },
      title: {
        display: true,
        color: "#ffffff",
        text: "Racing Line",
      },
    },
    scales: {
      x: {
        display: false,
        type: "linear" as const,
      },
      y: {
        display: false,
      },
    },
  };

  return (
    <div className={styles.container}>
      <Line data={chartData} options={chartOptions} />
    </div>
  );
}

export default RacingLineGraph;
